import Button from 'flarum/components/Button';
import Modal from 'flarum/components/Modal';

/**
 * The `DeleteUserModal` component shows a modal dialog which allows the user
 * to delete their account.
 */
export default class DeleteUserModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.isDeleted = false;
    this.loading = false;
  }

  className() {
    return (this.isDeleted)
      ? 'DeleteUserModal Modal--small user-deleted'
      : 'DeleteUserModal Modal--small';
  }

  title() {
    return (this.isDeleted)
      ? m('i', {className: "fas fa-check-circle icon-success"})
      : app.translator.trans('core.forum.user.settings.modal.confirm.header');
  }

  content() {
    if (!this.isDeleted) {
      // To confirm deletion
      return (
        m('div', {className: "Modal-body"}, [
          m('div', {className: "Form Form--centered"}, [
            m('div', {className: "Form-group"}, [
              m('p', {}, app.translator.trans('core.forum.user.settings.modal.confirm.text')),
              m('div', {className: "button-wrapper"}, [
                Button.component({
                  className: 'Button Button--danger Button--block',
                  loading: this.loading,
                  type: 'submit',
                }, app.translator.trans('core.forum.user.settings.modal.confirm.yes_button')),
                Button.component({
                  className: "Button Button--block",
                  disabled: this.loading,
                  onclick: this.hide.bind(this),
                }, app.translator.trans('core.forum.user.settings.modal.confirm.dismiss_button')),
              ]),
            ]),
          ])
        ])
      );
    }
    else {
      // User has been deleted
      return (
        m('div', {className: "Modal-body"}, [
          m('div', {className: "Form Form--centered"}, [
            m('div', {className: "Form-group"}, [
              m('p', {}, app.translator.trans('core.forum.user.settings.modal.deleted.upper_text')),
              m('p', {}, app.translator.trans('core.forum.user.settings.modal.deleted.lower_text')),
              Button.component({
                className: "Button Button--primary",
                loading: this.secondsLeft === 0,
                onclick: this.goToFrontpage,
              }, app.translator.trans('core.forum.user.settings.modal.deleted.dismiss_button', this.getRedirectToHomepageData())),
            ]),
          ])
        ])
      );
    }
  }

  onsubmit(e) {
    e.preventDefault();

    this.deleteUser();
  }

  deleteUser() {
    this.loading = true;

    app.request({
      url: `${app.forum.attribute('apiUrl')}/delete_user`,
      method: 'POST'
    }).then(() => {
      app.alerts.show(
        { type: 'success' },
        app.translator.trans('core.forum.user.settings.basics.user_deleted')
      );
      this.clearAlerts();
      this.isDeleted = true;
      this.secondsLeft = 10;
      this.countdown = setInterval(this.timerCountdown.bind(this), 1000);
    }).catch(() => {
      this.clearAlerts();
    });
  }

  timerCountdown() {
    this.secondsLeft -= 1;
    m.redraw();
    if (this.secondsLeft === 0) {
      clearInterval(this.countdown);
      this.goToFrontpage();
    }
  }

  goToFrontpage() {
    window.location = '/';
  }

  getRedirectToHomepageData() {
    return (this.secondsLeft > 0) ? {seconds: `(${this.secondsLeft})`} : {};
  }

  isDismissible() {
    return false;
  }

  clearAlerts = function () {
    setTimeout(() => {
      app.alerts.clear();
    }, 10000);
    this.loading = false;
    m.redraw();
  }
}
